import { Suspense } from "react";
import { LoaderFunction, RouteObject } from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { LoadingSplash } from "@songtradr/design-language";
import { OauthCallback } from "./OauthCallback";
import {
  LoaderData,
  exchangeFederatedToken,
  getFederatedParams,
  routes,
} from "./OauthCallback.Parts";

// LOADER
const OauthCallbackLoader: LoaderFunction = ({ request }): LoaderData => {
  const url = new URL(request.url);
  const { code, state } = getFederatedParams(url.searchParams);

  return { exchangeFederatedToken: exchangeFederatedToken(code, state) };
};

// WRAPPER
const OauthCallbackWrapper = () => (
  <Suspense fallback={<LoadingSplash />}>
    <OauthCallback />
  </Suspense>
);

// ROUTE
export const OauthCallbackRouteObject: RouteObject = {
  path: routes.oauthCallback,
  errorElement: <GeneralErrorPage />,
  Component: OauthCallbackWrapper,
  loader: OauthCallbackLoader,
};
